import { useEffect, useCallback } from 'react';

export default function useKeyboardShortcuts({
  pools = [],
  selectedPool,
  onSelectPool,
  searchInputRef,
  onClosePanel,
}) {
  const handleKeyDown = useCallback((e) => {
    // Don't intercept when modifier keys are held (browser shortcuts)
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    // Don't intercept when typing in inputs or contentEditable
    const tag = e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target.isContentEditable) {
      if (e.key === 'Escape') {
        e.target.blur();
        if (onClosePanel) onClosePanel();
      }
      return;
    }

    switch (e.key) {
      case '/': {
        e.preventDefault();
        if (searchInputRef?.current) {
          searchInputRef.current.focus();
        }
        break;
      }
      case 'j': {
        // Next pool
        if (!pools.length) break;
        const currentIdx = selectedPool
          ? pools.findIndex(p => p.id === selectedPool.id)
          : -1;
        const nextIdx = Math.min(currentIdx + 1, pools.length - 1);
        if (onSelectPool) onSelectPool(pools[nextIdx]);
        break;
      }
      case 'k': {
        // Previous pool
        if (!pools.length) break;
        const currentIdx = selectedPool
          ? pools.findIndex(p => p.id === selectedPool.id)
          : 0;
        const prevIdx = Math.max(currentIdx - 1, 0);
        if (onSelectPool) onSelectPool(pools[prevIdx]);
        break;
      }
      case 'Escape': {
        if (onClosePanel) onClosePanel();
        break;
      }
      default:
        break;
    }
  }, [pools, selectedPool, onSelectPool, searchInputRef, onClosePanel]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
}
